import * as React from 'react';

interface TabProps {
  onClick: (x: string) => void;
  label: string;
  activeTab: string;
}
export default (props: TabProps) => {
  const onClick = () => props.onClick(props.label);

  return (
    <button
      className={`${ props.activeTab === props.label ? 'tab-active' : ''}`}
      onClick={onClick}
    >
      {props.label}
    </button>
  );
};
